import React from 'react';
import '../../styles/layout.css';

/**
 * SectionElement - Full-width container with background and padding
 * This is a container element that holds other elements (rows, grids, or direct content)
 */
const SectionElement = ({ element, children, isEditorMode }) => {
  const { props } = element;
  const {
    background = 'transparent',
    backgroundColor = '#ffffff',
    padding = 'medium',
    maxWidth = 'container',
    marginTop = 'none',
    marginBottom = 'none'
  } = props || {};

  const style = {};

  // Apply background
  if (background === 'color') {
    style.backgroundColor = backgroundColor;
  } else if (background === 'gradient') {
    // Could add gradient support later
    style.backgroundColor = backgroundColor;
  }

  return (
    <div
      className={`builder-section ${isEditorMode ? 'builder-editor-mode' : ''}`}
      data-padding={padding}
      data-max-width={maxWidth}
      data-margin-top={marginTop}
      data-margin-bottom={marginBottom}
      style={style}
    >
      {children}
    </div>
  );
};

export default SectionElement;
